import { api } from '@/api'
import type { DeviceModel, DeviceModelsResponse, Vendor, VendorsResponse } from '../types'

// GET /bff/vendors → { vendors }.
export function listVendors(): Promise<Vendor[]> {
  return api.get<VendorsResponse>('/vendors').then((data) => data.vendors)
}

// GET /bff/vendors/{id}/models → { models }.
export function listVendorModels(vendorId: string): Promise<DeviceModel[]> {
  return api.get<DeviceModelsResponse>(`/vendors/${vendorId}/models`).then((data) => data.models)
}
